export const API_URL = window._env_.API_URL
export const API_TOKEN = window._env_.API_TOKEN
export const DIGITAL_ID_API_URL = window._env_.DIGITAL_ID_API_URL
export const DIGITAL_ID_CLIENT_ID= window._env_.DIGITAL_ID_CLIENT_ID
export const DIGITAL_ID_REDIRECT_URI = window._env_.DIGITAL_ID_REDIRECT_URI
export const GNB_WEBSITE_EN = window._env_.GNB_WEBSITE_EN
export const TOU_LINK_EN = window._env_.TOU_LINK_EN
export const PRIVACY_LINK_EN = window._env_.PRIVACY_LINK_EN
export const FAQ_LINK_EN = window._env_.FAQ_LINK_EN
export const HELP_LINK_EN = window._env_.HELP_LINK_EN
export const GNB_WEBSITE_FR = window._env_.GNB_WEBSITE_FR
export const TOU_LINK_FR = window._env_.TOU_LINK_FR
export const PRIVACY_LINK_FR = window._env_.PRIVACY_LINK_FR
export const FAQ_LINK_FR = window._env_.FAQ_LINK_FR
export const HELP_LINK_FR = window._env_.HELP_LINK_FR
export const GA_TOKEN = window._env_.GA_TOKEN
export const DEBUG = window._env_.DEBUG
export const TIMEOUT = 10000;
export const HIAL_TIMEOUT = window._env_.HIAL_TIMEOUT
export const VERSION = "v0.1.0";
export const VERSION_DATE = "2020-04-05"
export const GATEWAY_TIMEOUT = window._env_.GATEWAY_TIMEOUT;
export const VSF_CLIENT_NAME = "MyHeathNB"
export const REGISTER_LINK = window._env_.REGISTER_LINK;
export const LOGOUT_URL = window._env_.LOGOUT_URL;
export const PDF_DATE_LIMIT = window._env_.PDF_DATE_LIMIT;
export const USE_MANUAL_TOKEN = window._env_.USE_MANUAL_TOKEN === "true"
export const MANUAL_TOKEN = window._env_.MANUAL_TOKEN
export const MANAGE_ACCOUNT_LINK_EN = window._env_.MANAGE_ACCOUNT_LINK_EN;
export const MANAGE_ACCOUNT_LINK_FR = window._env_.MANAGE_ACCOUNT_LINK_FR;
export const TERMS_OF_USE_VERSION = window._env_.TERMS_OF_USE_VERSION;
export const DISABLE_HEADER_FOOTER = window._env_.DISABLE_HEADER_FOOTER === "true"
export const ONLY_ALLOW_EMBED = window._env_.ONLY_ALLOW_EMBED === "true"